import { render, staticRenderFns } from "./centralized-shop.vue?vue&type=template&id=dab48a3a&scoped=true"
import script from "./centralized-shop.vue?vue&type=script&lang=js"
export * from "./centralized-shop.vue?vue&type=script&lang=js"
import style0 from "./centralized-shop.vue?vue&type=style&index=0&id=dab48a3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab48a3a",
  null
  
)

export default component.exports